// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.width-auto {
    width: auto;
}

.dataTables_info {
    padding-top: 0.85rem;
}

.text-error {
    color: #dc3545;
    font-size: 14px;
}

.error-fullname {
    margin-top: -10px;
}

/* #candidateList tr.odd td.dataTables_empty{
	display: none!important;
} */
.text-error {
    font-size: 14px;
}

.bp-btn-width-search {
    width: 180px;
    height: 37px;
}

@media only screen and (min-width: 767.98px) {
    .add-btn-ot {
        margin-left: 32px;
    }
}

@media only screen and (min-width: 1238.98px) {
    .add-btn-ot {
        margin-left: unset;
    }
}

@media only screen and (max-width: 767.98px) {
    .pb-16{
        padding-bottom: 8px;
    }
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVtcGxveWVlLXNlYXJjaC1mb3JtLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxXQUFXO0FBQ2Y7O0FBRUE7SUFDSSxvQkFBb0I7QUFDeEI7O0FBRUE7SUFDSSxjQUFjO0lBQ2QsZUFBZTtBQUNuQjs7QUFFQTtJQUNJLGlCQUFpQjtBQUNyQjs7QUFFQTs7R0FFRztBQUNIO0lBQ0ksZUFBZTtBQUNuQjs7QUFFQTtJQUNJLFlBQVk7SUFDWixZQUFZO0FBQ2hCOztBQUVBO0lBQ0k7UUFDSSxpQkFBaUI7SUFDckI7QUFDSjs7QUFFQTtJQUNJO1FBQ0ksa0JBQWtCO0lBQ3RCO0FBQ0o7O0FBRUE7SUFDSTtRQUNJLG1CQUFtQjtJQUN2QjtBQUNKIiwiZmlsZSI6ImVtcGxveWVlLXNlYXJjaC1mb3JtLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIud2lkdGgtYXV0byB7XG4gICAgd2lkdGg6IGF1dG87XG59XG5cbi5kYXRhVGFibGVzX2luZm8ge1xuICAgIHBhZGRpbmctdG9wOiAwLjg1cmVtO1xufVxuXG4udGV4dC1lcnJvciB7XG4gICAgY29sb3I6ICNkYzM1NDU7XG4gICAgZm9udC1zaXplOiAxNHB4O1xufVxuXG4uZXJyb3ItZnVsbG5hbWUge1xuICAgIG1hcmdpbi10b3A6IC0xMHB4O1xufVxuXG4vKiAjY2FuZGlkYXRlTGlzdCB0ci5vZGQgdGQuZGF0YVRhYmxlc19lbXB0eXtcblx0ZGlzcGxheTogbm9uZSFpbXBvcnRhbnQ7XG59ICovXG4udGV4dC1lcnJvciB7XG4gICAgZm9udC1zaXplOiAxNHB4O1xufVxuXG4uYnAtYnRuLXdpZHRoLXNlYXJjaCB7XG4gICAgd2lkdGg6IDE4MHB4O1xuICAgIGhlaWdodDogMzdweDtcbn1cblxuQG1lZGlhIG9ubHkgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjcuOThweCkge1xuICAgIC5hZGQtYnRuLW90IHtcbiAgICAgICAgbWFyZ2luLWxlZnQ6IDMycHg7XG4gICAgfVxufVxuXG5AbWVkaWEgb25seSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDEyMzguOThweCkge1xuICAgIC5hZGQtYnRuLW90IHtcbiAgICAgICAgbWFyZ2luLWxlZnQ6IHVuc2V0O1xuICAgIH1cbn1cblxuQG1lZGlhIG9ubHkgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiA3NjcuOThweCkge1xuICAgIC5wYi0xNntcbiAgICAgICAgcGFkZGluZy1ib3R0b206IDhweDtcbiAgICB9XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/employees/employee-search-form/employee-search-form.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;GAEG;AACH;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA,ohDAAohD","sourcesContent":[".width-auto {\n    width: auto;\n}\n\n.dataTables_info {\n    padding-top: 0.85rem;\n}\n\n.text-error {\n    color: #dc3545;\n    font-size: 14px;\n}\n\n.error-fullname {\n    margin-top: -10px;\n}\n\n/* #candidateList tr.odd td.dataTables_empty{\n\tdisplay: none!important;\n} */\n.text-error {\n    font-size: 14px;\n}\n\n.bp-btn-width-search {\n    width: 180px;\n    height: 37px;\n}\n\n@media only screen and (min-width: 767.98px) {\n    .add-btn-ot {\n        margin-left: 32px;\n    }\n}\n\n@media only screen and (min-width: 1238.98px) {\n    .add-btn-ot {\n        margin-left: unset;\n    }\n}\n\n@media only screen and (max-width: 767.98px) {\n    .pb-16{\n        padding-bottom: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
